import { defineStore } from 'pinia'

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    visible: false,
    text: '',
    color: 'info', // info, success, warning, error
    timeout: 5000
  }),

  actions: {
    /**
     * Zobrazenie notifikácie
     * @param {Object} options - Nastavenia notifikácie
     * @param {string} options.text - Text notifikácie
     * @param {string} options.color - Farba notifikácie (info, success, warning, error)
     * @param {number} options.timeout - Čas zobrazenia v ms
     * Prijme aj zápis show('Text', 'success') - niektoré časti aplikácie ho tak volajú.
     */
    show(options, color) {
      const nastavenia = (options && typeof options === 'object') ? options : { text: options, color };
      this.text = nastavenia.text || 'Notifikácia';
      this.color = nastavenia.color || 'info';
      this.timeout = nastavenia.timeout || 5000;
      this.visible = true;
    },

    /**
     * Skrytie notifikácie
     */
    hide() {
      this.visible = false;
    },

    /**
     * Zobrazenie úspešnej notifikácie
     * @param {string} text - Text notifikácie
     * @param {number} timeout - Čas zobrazenia v ms
     */
    success(text, timeout = 5000) {
      this.show({
        text,
        color: 'success',
        timeout
      });
    },

    /**
     * Zobrazenie chybovej notifikácie
     * @param {string} text - Text notifikácie
     * @param {number} timeout - Čas zobrazenia v ms
     */
    error(text, timeout = 5000) {
      this.show({
        text,
        color: 'error',
        timeout
      });
    },

    /**
     * Zobrazenie informačnej notifikácie
     * @param {string} text - Text notifikácie
     * @param {number} timeout - Čas zobrazenia v ms
     */
    info(text, timeout = 5000) {
      this.show({
        text,
        color: 'info',
        timeout
      });
    },

    /**
     * Zobrazenie varovnej notifikácie
     * @param {string} text - Text notifikácie
     * @param {number} timeout - Čas zobrazenia v ms
     */
    warning(text, timeout = 5000) {
      this.show({
        text,
        color: 'warning',
        timeout
      });
    },

    /**
     * Alias pre show() - kompatibilita s pôvodným kódom (predtým bol len v stores/notification.js,
     * ktorý mal rovnaké id store, takže podľa poradia importov volanie padalo na TypeError)
     * @param {Object|string} options - Nastavenia notifikácie alebo text
     * @param {string} color - Farba, ak je prvý parameter text
     */
    showSnackbar(options, color) {
      this.show(options, color);
    }
  }
})
